import { CommonModule } from "@angular/common";
import { Component, EventEmitter, Input, Output } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { TranslateModule } from "@ngx-translate/core";
import { LessorType } from "@shared/enums/lessorType";
import { OptionalService } from "@shared/enums/optional-service.enum";
import { PolicyFields } from "@shared/enums/policy-fields.enum";
import {
  getDropdownClass,
  getInputClass,
  getIsEditable,
  getIsVisible,
} from "@shared/helpers/contract-edition.helper";
import { LessorList } from "@shared/models/lessor";
import { LessorDataDto, PolicyDetail } from "@shared/models/policy-details";
import { PolicyFieldsVM } from "@shared/models/policy-field-vm.model";
import { DropdownModule } from "primeng/dropdown";

@Component({
  selector: "app-contract-edition-lessor-mrh",
  standalone: true,
  imports: [TranslateModule, FormsModule, DropdownModule, CommonModule],
  templateUrl: "./contract-edition-lessor-mrh.component.html",
})
export class ContractEditionLessorMrhComponent {
  @Input() policyFieldsVM!: PolicyFieldsVM;
  @Input() policyDetails!: PolicyDetail;
  @Input() policyDetailsCopy!: PolicyDetail;
  @Input() lessorData!: LessorDataDto;
  @Input() lessorDataCopy!: LessorDataDto;
  @Input() lessorList!: LessorList;
  @Input() lessorOptions!: string[];
  @Input() lessorSocialSelected!: boolean;
  @Input() hasEndorsementWait4Sign!: boolean;
  @Output() emitFormValidity = new EventEmitter<number>();
  PolicyFields = PolicyFields;
  OptionalService = OptionalService;
  getIsVisible = getIsVisible;
  getIsEditable = getIsEditable;
  getInputClass = getInputClass;
  getDropdownClass = getDropdownClass;

  lessorTypeOptions = [LessorType.Social, LessorType.Private];
  lessorDataNameInitialValue = "";
  lessorDataName!: string;
  yesNoValues: { label: string; value: boolean }[] = [
    { label: "Oui", value: true },
    { label: "Non", value: false },
  ];

  lessorTypeHasChanged = false;
  lessorNameHasChanged = false;
  houseIsOccupedHasChanged = false;
  referenceClientHasChanged = false;
  localPrincipalHasChanged = false;
  lessorMailSendDateHasChanged = false;
  lessorDataNameHasChanged = false;
  lessorMailHasChanged = false;

  onLessorTypeChange() {
    this.lessorTypeHasChanged = this.lessorDataCopy.lessorType !== this.lessorData?.lessorType;
    this.lessorSocialSelected = this.lessorDataCopy.lessorType === LessorType.Social;
  }

  onLessorNameChange() {
    this.lessorNameHasChanged = this.lessorDataCopy.name !== this.lessorData?.name;
    const lessorData = this.lessorList.find(x => x.name === this.lessorDataCopy.name);
    if (lessorData) {
      this.lessorDataCopy.email = lessorData.email;
      this.onLessorDataNameChange();
    }
  }
  onLessorDataNameChange() {
    this.lessorDataNameHasChanged = this.lessorDataNameInitialValue !== this.lessorDataName;
  }

  onLessorMailChange() {
    this.lessorMailHasChanged = this.lessorData.email !== this.lessorDataCopy.email;
    this.emitFormValidity.emit(0);
  }

  onHouseOccupedChange() {
    this.houseIsOccupedHasChanged = this.lessorData.houseIsOccuped !== this.lessorDataCopy.houseIsOccuped;
  }

  onReferenceClientChange() {
    this.referenceClientHasChanged = this.lessorData.ref1 !== this.lessorDataCopy.ref1;
    this.emitFormValidity.emit(0);
  }

  onLocalPrincipalChange() {
    this.localPrincipalHasChanged = this.lessorData.ref2 !== this.lessorDataCopy.ref2;
    this.emitFormValidity.emit(0);
  }

  onLessorMailSendDateChange() {
    this.lessorMailSendDateHasChanged = this.lessorDataCopy.ref1 !== this.lessorData.ref1;
    this.emitFormValidity.emit(0);
  }
}
